import { AiOutlineHome, AiOutlineUser, AiOutlineWallet } from "react-icons/ai";
import { BiBook, BiMessageSquareDetail } from "react-icons/bi";
import { RiServiceLine } from "react-icons/ri";
import { TbCertificate } from "react-icons/tb";
// import { MdOutlineAutoAwesome } from "react-icons/md";

export const navItems = [
  { href: "#header", icon: <AiOutlineHome />, title: "HOME" },
  { href: "#about", icon: <AiOutlineUser />, title: "ABOUT" },
  { href: "#experience", icon: <BiBook />, title: "EXPERIENCE" },
  {
    href: "#certifications",
    icon: <TbCertificate />,
    title: "CERTIFICATIONS",
  },

  { href: "#services", icon: <RiServiceLine />, title: "SERVICES" },
  { href: "#portfolio", icon: <AiOutlineWallet />, title: "PORTFOLIO" },
  // {
  //   href: "#testimonials",
  //   icon: <MdOutlineAutoAwesome />,
  //   title: "TESTIMONIALS",
  // },
  { href: "#contact", icon: <BiMessageSquareDetail />, title: "CONTACT" },
];
